class ImageComparison extends HTMLElement {
    constructor() {
      super();
  
      Motion.inView(this, async () => {
        await this.imageLoaded(this.media);
        this.init();
      });
    }
  
    get button() {
      return this.querySelector('button');
    }
  
    get bounding() {
      return this.getBoundingClientRect();
    }
  
    get horizontal() {
      return this.getAttribute('data-layout') === 'horizontal';
    }
  
    get media() {
      return Array.from(this.querySelectorAll('img, svg'));
    }
  
    init() {
      this.active = false;
  
      this.button.addEventListener('touchstart', this.startHandler.bind(this), { passive: true });
      document.body.addEventListener('touchend', this.endHandler.bind(this), { passive: true });
      document.body.addEventListener('touchmove', this.onHandler.bind(this), { passive: true });
      
      this.button.addEventListener('mousedown', this.startHandler.bind(this));
      document.body.addEventListener('mouseup', this.endHandler.bind(this));
      document.body.addEventListener('mousemove', this.onHandler.bind(this));
  
      setTimeout(() => this.animate(), 1e3);
    }
  
    animate() {
      this.setAttribute('animate', '');
  
      this.classList.add('animating');
      setTimeout(() => {
        this.classList.remove('animating');
      }, 1e3);
    }
  
    startHandler() {
      this.active = true;
      this.classList.add('scrolling');
    }
  
    endHandler() {
      this.active = false;
      this.classList.remove('scrolling');
    }
  
    onHandler(e) {
      if (!this.active) return;
      
      const event = (e.touches && e.touches[0]) || e;
      let x = this.horizontal
                  ? event.pageX - (this.bounding.left + window.scrollX)
                  : event.pageY - (this.bounding.top + window.scrollY);
                  
      this.scrollIt(x);
    }

    imageLoaded(imageOrArray) {
        if (!imageOrArray) {
            return Promise.resolve();
        }
        imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
        return Promise.all(imageOrArray.map((image) => {
            return new Promise((resolve) => {
            if (image.tagName === "IMG" && image.complete || !image.offsetParent) {
                resolve();
            } else {
                image.onload = () => resolve();
            }
            });
        }));
    }
  
    scrollIt(x) {
      const distance = this.horizontal ? this.clientWidth : this.clientHeight;
      
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, (Math.min(x, max)));
      const mousePercent = (mouseX * 100) / distance;
      this.style.setProperty('--percent', mousePercent + '%');
    }
  }
  customElements.define('image-comparison', ImageComparison);